import { LaborOperation } from "../models/labor-operation";

export class LaborOperationMapper {
    // Maps a labor operation API response to a {@link LaborOperation}.
    // @param partComponentResponse The API part component to convert.
    // @returns The mapped {@link LaborOperation}.
    public static mapLaborOperation(laborOperationResponse: any) {
        return new LaborOperation(laborOperationResponse.id,
                                  laborOperationResponse.name,
                                  laborOperationResponse.sortOrder,
                                  laborOperationResponse.isActive)
    }
}